import { useGTMPageTracking } from '../hooks/useGTMPageTracking';

export function GTMPageTracker() {
    useGTMPageTracking();
    return null;
}
